import type { PaginationWithAssignmentFilters } from '@repo/types/assignments';

import { assignmentErrorMessages } from '@repo/lib/messages/assignmentErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { AssignmentService } from './assignmentService';
import { AssignmentKey } from './keys';

export function useGetAssignedAssignments(params?: PaginationWithAssignmentFilters, enabled = true) {
  const query = useQuery({
    queryKey: [AssignmentKey.ASSIGNED_ASSIGNMENTS, params],
    queryFn: () => AssignmentService.getAssignedAssignments(params).then((response) => response.data),
    enabled,
  });

  const errorMessage = useErrorMessage(query.error, assignmentErrorMessages);

  return { ...query, errorMessage };
}
